export const post = {
    title: "How to prepare for meetings in corporate tech",
    date: "May 26, 2026",
    readTime: "4 min read",
    author: "Aisha",
    content: `

    <p>Meetings, we all do them. Corporate meetings, not everyone, but meetings are meetings. I noticed nobody teaches you how to go about with this kind of stuff. Some may learn by doing and some perhaps have good role models, mentors, or sponsors in their lives who show them the way. But I don't think you learn these things in school, maybe some do, I certainly didn't. I believe these are the kinds of things you learn by doing and with experience.</p>

    <p>Now when it comes to developers or people who are technical,
    I cannot say for a fact how everyone's journey is,
    but I do know that there are certain skills that developers are often known for, the technical things.
    But there is another side to it, soft skills,
    and that is something we are not always recognized for or maybe misunderstood on.
    But, we don't have to go into details maybe next time.
    Anyways, today I would like to share some of the things I learned and the things that I think are crucial when attending corporate meetings. These tips have helped me and as always I want to share with you all.</p>

    <p>So let's get into it. First thing:</p>

    <h2 id="get-an-overview">1. Get an overview of the meeting</h2>
    <p>Having an overview of the meeting you are attending is basically like having a general idea of what the meeting is about.
    This will help you get prepared ahead of the meeting. Don't be lazy and say, well, my presence is what counts and that's that. No.
    You need to prepare, have this overview, and then you can walk into the meeting room without feeling lost.</p>

    <h2 id="know-the-participants">2. Know who the meeting participants are</h2>
    <p>The next thing that I think is very important to do, and also to understand ahead of the meeting, is to know who the meeting participants are.
    This is going to help you understand the type of people who are going to be in the room.
    It's also going to help you to know what their roles are, what their titles are,
    versus you walking into a room and just being like, who are these people?
    That means you are not prepared. So to be prepared,
    make sure you know who is going to be a part of the meeting that you are invited to.</p>

    <h2 id="review-the-agenda">3. Familiarize yourself with the meeting agenda</h2>
    <p>Next, familiarize yourself with the meeting agenda.
    Look at the items on the meeting agenda and get to know what are some of the things
    that are going to be discussed in the meeting, and think about what you are going to bring to the table
    as a participant of the meeting. So yes, it's very important for you to look into the meeting agenda.
    You might also go to a meeting where there is no agenda. But that's why the overview of the meeting, for example the meeting invite title, gives
    you an idea of what's going to be talked about. Don't be worried if you go to a meeting
    and you don't have any agenda.</p>

    <h2 id="listen-and-engage">4. Listen, but speak up</h2>
    <p>Another thing is when you're at the meeting,
    I want you to listen. I want you to be the person that listens to what's going on and understands different people,
    different perspectives. Don't be that person who just wants everybody to hear them speak.
    Be that person that listens, because when you listen, you learn, and you learn from others. You get different perspectives.
    But don't be afraid to share your opinion. Feel free to ask questions. Don't be that person that sits at the meeting
    and doesn't say anything. It's important for you to contribute.
    There's a reason why you are sent to a meeting. Don't feel like your questions are stupid, because you never know what discussions can arise out of a question.
    And so that's why for me I think it's important to ask questions,
    and also don't keep on repeating yourself or asking questions for the sake of it.
    Ask questions because you genuinely feel like there's a need to ask. But yes, when you are at a meeting,
    make sure you ask questions because your opinion counts.</p>

    <h2 id="take-notes">5. Take notes</h2>
    <p>Another thing that I think is important is to have your notebook and your pen, or carry your computer with you,
    because you need to take notes. And this is not old school. I like to use my computer as much as I can,
    but I always take my notebook and pen with me because things might be said that are important and relevant to my role.
    And if I don't have anything or anywhere to document it, what's the point? Of course,
    you can try to remember and use your brain, but the brain can only take so much.
    So try to take your pen and notebook with you, or your computer if you're a person who likes to type instead.
    I like to take my notebook and pen with me and it never fails me, I'm telling you.
    So that's the tip. If there is anything that you're going to take away from this blog post, take that.</p>

    <h2 id="follow-up">6. Follow up</h2>
    <p>Another thing that I would like to share is for you to follow up. So sometimes when you attend
    a meeting there might be things that are not clear or there might be things that you're unsure of,
    and so if you are unsure of certain things you should reach out to one of the meeting participants,
    or all of them, and try to get clarification on the things that you are not clear about, and they
    will potentially help you out.</p>

    <h2 id="repeat">7. Repeat</h2>
    <p>And the last and final tip would be: repeat.</p>

    <h2 id="summary">In summary</h2>
    <p>Don't forget to have an overview of what the meeting is about.
    Familiarize yourself with who is attending the meeting.
    Take your notebook and pen with you or your computer, you decide.
    Familiarize yourself with the meeting agenda. Listen as much as possible. Ask relevant questions,
    or ask any question that you feel like, because no question is stupid.
    Follow up when you can, and literally repeat. Thank you so much for reading. Take care of yourself. Always remember you are in that meeting
    because you're meant to be there and preparation is everything.</p>
    `
};
